import React, { createContext, useContext, useEffect, useState } from 'react';

import { dataCache } from '../utils/dataCache';

const ArchitectLinksContext = createContext({ linkableArchitects: null });

export function ArchitectLinksProvider({ children }) {
  const [linkableArchitects, setLinkableArchitects] = useState(null);

  useEffect(() => {
    let cancelled = false;
    dataCache
      .getArchitectRankings({})
      .then((architects) => {
        if (cancelled) return;
        const map = new Map();
        if (Array.isArray(architects)) {
          architects.forEach((a) => {
            if (a?.name && a?.slug) map.set(String(a.name).trim().toLowerCase(), a.slug);
          });
        }
        setLinkableArchitects(map);
      })
      .catch(() => {
        if (!cancelled) setLinkableArchitects(new Map());
      });
    return () => { cancelled = true; };
  }, []);

  const getArchitectSlug = (name) => {
    if (!linkableArchitects || !name) return null;
    return linkableArchitects.get(String(name).trim().toLowerCase()) || null;
  };

  return (
    <ArchitectLinksContext.Provider value={{ getArchitectSlug }}>
      {children}
    </ArchitectLinksContext.Provider>
  );
}

export function useArchitectLinks() {
  const ctx = useContext(ArchitectLinksContext);
  return ctx || { getArchitectSlug: () => null };
}
